
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA en Provence-Alpes-Côte d’Azur dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads en Provence-Alpes-Côte d’Azur certifiée Google Partner, accompagne les entreprises pour accroître leur visibilité sur Google et attirer des prospects qualifiés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads en Provence-Alpes-Côte d’Azur dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads en Provence-Alpes-Côte d’Azur certifiée Google Partner, accompagne les entreprises pour accroître leur visibilité sur Google et attirer des prospects qualifiés.",
        },
      ],
    };
  },
};
